import { state, setState, INKO_STATES } from "./state.js";

import { initChat } from "./chat.js";

import { initPreview } from "./preview.js";

import { initUploader } from "./uploader.js";

document.addEventListener("DOMContentLoaded", () => {
    const root = document.querySelector("#inko-studio");

    if (!root) {
        return;
    }

    initChat(root);

    initPreview(root);

    initUploader(root);

    initProgressUI(root);

    initGenerateListener(root);

    initPolling(root);
});

function initGenerateListener(root) {
    window.addEventListener("inko:ready-to-generate", async (event) => {
        const data = event.detail;

        if (!data.design_id) {
            return;
        }

        await generateDesign(root, data.design_id);
    });
}

async function generateDesign(root, designId) {
    const button = root.querySelector("#inko-send-button");

    try {
        setState({
            status: INKO_STATES.GENERATING,
        });

        const response = await fetch(root.dataset.generateUrl, {
            method: "POST",

            headers: {
                "Content-Type": "application/json",

                Accept: "application/json",

                "X-CSRF-TOKEN": root.dataset.csrf,
            },

            credentials: "same-origin",

            body: JSON.stringify({
                design_id: designId,
            }),
        });

        const result = await response.json();

        if (!response.ok) {
            throw new Error(result.message || "Gagal memulai generation.");
        }

        setState({
            status: INKO_STATES.GENERATING,
        });
    } catch (error) {
        setState({
            status: INKO_STATES.FAILED,
        });

        console.error("INKO generation:", error);
    }
}

function initPolling(root) {
    window.addEventListener("inko:state", () => {
        if (
            state.designId &&
            [
                INKO_STATES.GENERATING,
                INKO_STATES.COMPOSING,
                INKO_STATES.VALIDATING,
            ].includes(state.status)
        ) {
            startPolling(root);
        }
    });
}

function startPolling(root) {
    if (state.pollingTimer) {
        return;
    }

    state.pollingTimer = setInterval(() => {
        pollStatus(root);
    }, 2500);
}

async function pollStatus(root) {
    if (!state.designId) {
        return;
    }

    try {
        const response = await fetch(
            `${root.dataset.designUrl}/${state.designId}/status`,
            {
                headers: {
                    Accept: "application/json",
                },

                credentials: "same-origin",
            },
        );

        const result = await response.json();

        if (!response.ok) {
            return;
        }

        const data = result.data || {};

        setState({
            status: data.status || state.status,

            design: data,
        });

        window.dispatchEvent(
            new CustomEvent("inko:design", {
                detail: data,
            }),
        );

        if (data.status === "completed" || data.status === "failed") {
            clearInterval(state.pollingTimer);

            state.pollingTimer = null;
        }
    } catch (error) {
        console.error("INKO status:", error);
    }
}

function initProgressUI(root) {
    const progress = root.querySelector("#inko-progress");

    const text = root.querySelector("#inko-progress-text");

    const statusText = root.querySelector("#inko-status-text");

    const messages = {
        thinking: "INKO sedang memahami brief kamu...",

        clarifying: "INKO sedang memastikan informasi desain...",

        asset_matching: "INKO sedang mencari asset resmi...",

        waiting_asset: "INKO menunggu asset resmi...",

        planning: "INKO sedang menyusun konsep visual...",

        generating: "INKO sedang menghasilkan visual...",

        composing: "INKO sedang menyelesaikan layout...",

        validating: "INKO sedang memeriksa kesiapan cetak...",

        completed: "Desain siap.",

        failed: "INKO mengalami gangguan.",
    };

    window.addEventListener("inko:state", (event) => {
        const status = event.detail.status;

        statusText.textContent = status || "Siap";

        if (messages[status]) {
            text.textContent = messages[status];
        }

        const busy = [
            "thinking",
            "asset_matching",
            "planning",
            "generating",
            "composing",
            "validating",
        ].includes(status);

        progress.hidden = !busy;
    });
}
